import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FiMapPin, FiPhone, FiMail } from "react-icons/fi";
import { FaLinkedinIn, FaFacebookF } from "react-icons/fa";
import { useRecaptcha } from "../Components/ReCaptcha";


const Contact = () => {
  useEffect(() => {
    document.title = "Contact Us | Shivam Transworld";

    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) {
      metaDesc.setAttribute(
        "content",
        "Get in touch with Shivam Transworld team to discuss your transportation and logistics requirements across India."
      );
    }

      const canonical = document.querySelector("link[rel='canonical']");
  if (canonical) {
    canonical.setAttribute("href", "https://shivamtransworld.in/contact-us");
  }

  const ogTitle = document.querySelector("meta[property='og:title']");
  if (ogTitle) {
    ogTitle.setAttribute(
      "content",
      "Contact Us | Shivam Transworld"
    );
  }

    const ogDesc = document.querySelector("meta[property='og:description']");
  if (ogDesc) {
    ogDesc.setAttribute(
      "content",
      "Get in touch with Shivam Transworld team to discuss your transportation and logistics requirements across India."
    );
  }

  const ogUrl = document.querySelector("meta[property='og:url']");
  if (ogUrl) {
    ogUrl.setAttribute("content", "https://shivamtransworld.in/contact-us");
  }

    const ogImage = document.querySelector("meta[property='og:image']");
  if (ogImage) {
    ogImage.setAttribute(
      "content",
      "https://shivamtransworld.in/image/home-about.webp"
    );
  }

    const twitterTitle = document.querySelector("meta[name='twitter:title']");
  if (twitterTitle) {
    twitterTitle.setAttribute(
      "content",
      "Contact Us | Shivam Transworld"
    );
  }

    const twitterDesc = document.querySelector(
    "meta[name='twitter:description']"
  );
  if (twitterDesc) {
    twitterDesc.setAttribute(
      "content",
      "Get in touch with Shivam Transworld team to discuss your transportation and logistics requirements across India."
    );
  }

    const twitterImage = document.querySelector("meta[name='twitter:image']");
  if (twitterImage) {
    twitterImage.setAttribute(
      "content",
      "https://shivamtransworld.in/image/home-about.webp"
    );
  }
  }, []);

  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const generateToken = useRecaptcha();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  

  if (!form.name || !form.email || !form.message) {
    toast.error("Please fill all required fields");
    return;
  }

  setLoading(true);

  // Generate reCAPTCHA token
  generateToken(async (token) => {
    try {
      // 🔐 Step 1: Verify reCAPTCHA token
      const recaptchaData = new FormData();
      recaptchaData.append("secret", "6LcxfIEsAAAAACXphtu7AnEUYt8vo0_E12rS5hBA");
      recaptchaData.append("response", token);

      const verifyRes = await axios.post(
        "https://api.sendmail.adhyaynam.in/recaptcha-verify",
        recaptchaData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      // ✅ Step 2: Check score
      if (verifyRes.data.score > 0.5) {
        // 📩 Step 3: Send email (same as your current setup)
console.log("Recaptcha Score:", verifyRes.data.score);
        const template = `
          <h3>New Contact Form Submission</h3>
          <p><strong>Name:</strong> ${form.name}</p>
          <p><strong>Email:</strong> ${form.email}</p>
          <p><strong>Subject:</strong> ${form.subject}</p>
          <p><strong>Message:</strong> ${form.message}</p>
        `;

        const data = new FormData();
        data.append("title", "Website Contact Form");
        data.append("to_email", "logistics@shivamtransworld.in");
        data.append("cc", "arkayappsseo@gmail.com, sales@arkayapps.com");
        data.append("subject", "Website Contact Form");
        data.append("template", template);

        await axios.post(
          "https://api.sendmail.adhyaynam.in/send-mail/two",
          data,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        toast.success("Message sent successfully 🎉");

        // Reset form
        setForm({
          name: "",
          email: "",
          subject: "",
          message: "",
        });
      } else {
        toast.error("Spam detected. Please try again.");
      }
    } catch (error) {
      console.log(error.response?.data || error);
      toast.error("Verification failed. Please try again!");
    } finally {
      setLoading(false);
    }
    
  });
};
  return (
    <>
     <ToastContainer position="top-right" autoClose={3000} />
      <div className="spacing-div"></div>

      <section className="contact-section">
        <div className="contact-container">

          {/* LEFT FORM */}
          <motion.div
            className="contact-form"
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7, ease: "easeOut" }}
            viewport={{ once: true }}
          >
            <p className="section-label">CONTACT</p>

            <motion.h1
              className="section-title h1-heading"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.15, duration: 0.6 }}
              viewport={{ once: true }}
            >
              Get in Touch with Our Logistics Team
            </motion.h1>

            <motion.form
              onSubmit={handleSubmit} // hook submission
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={{
                hidden: {},
                visible: { transition: { staggerChildren: 0.1 } },
              }}
            >
              {[
                { label: "Your Name (required)", name: "name" },
                { label: "Your Email (required)", name: "email" },
                { label: "Subject", name: "subject" },
              ].map((field, i) => (
                <motion.div
                  className="form-group"
                  key={i}
                  variants={{
                    hidden: { opacity: 0, y: 20 },
                    visible: { opacity: 1, y: 0 },
                  }}
                >
                  <label>{field.label}</label>
                  <input
                    type="text"
                    name={field.name}
                    value={form[field.name]}
                    onChange={handleChange}
                    required={field.name !== "subject"}
                  />
                </motion.div>
              ))}

              <motion.div
                className="form-group"
                variants={{
                  hidden: { opacity: 0, y: 20 },
                  visible: { opacity: 1, y: 0 },
                }}
              >
                <label>Your Message</label>
                <textarea
                  rows="6"
                  name="message"
                  value={form.message}
                  onChange={handleChange}
                  required
                />
              </motion.div>

              <motion.button
                type="submit"
                className="send-btn"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                disabled={loading}
              >
                {loading ? "Sending..." : "SEND"}
              </motion.button>
            </motion.form>
          </motion.div>

          {/* RIGHT INFO */}
          <motion.div
            className="contact-info"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={{
              hidden: {},
              visible: { transition: { staggerChildren: 0.2 } },
            }}
          >

            {/* BLOCK 1 */}
            <motion.div
              className="info-block"
              variants={{
                hidden: { opacity: 0, y: 30 },
                visible: { opacity: 1, y: 0 },
              }}
            >
              <h2 className="section-title">
                <span>01.</span> Before Contacting Us
              </h2>
              <p>
               Please ensure you have reviewed our services and solutions before contacting us.
              </p>
            </motion.div>

            {/* BLOCK 2 */}
            <motion.div
              className="info-block"
              variants={{
                hidden: { opacity: 0, y: 30 },
                visible: { opacity: 1, y: 0 },
              }}
            >
              <h2 className="section-title">
                <span>02.</span> Contact Information
              </h2>
              <ul>
                <li>
                  <motion.span
                    initial={{ scale: 0 }}
                    whileInView={{ scale: 1 }}
                    transition={{ type: "spring", stiffness: 250 }}
                    viewport={{ once: true }}
                  >
                    <FiMapPin />
                  </motion.span>
                 Shop No : 70 / 1
Tanker's Association Building,
Beside S T Bus Station,
NH - 8A, Gandhidham - 370201
                </li>
               <li>
  <motion.span
    initial={{ scale: 0 }}
    whileInView={{ scale: 1 }}
    transition={{ type: "spring", stiffness: 250, delay: 0.1 }}
    viewport={{ once: true }}
  >
    <FiPhone />
  </motion.span>

  <a href="tel:+919132287287">
    +91 9132 287 287
  </a>
</li>

<li>
  <motion.span
    initial={{ scale: 0 }}
    whileInView={{ scale: 1 }}
    transition={{ type: "spring", stiffness: 250, delay: 0.2 }}
    viewport={{ once: true }}
  >
    <FiMail />
  </motion.span>

  <a href="mailto:logistics@shivamtransworld.in">
   logistics@shivamtransworld.in
  </a>
</li>

              </ul>
            </motion.div>

            {/* BLOCK 3 */}
            <motion.div
              className="info-block"
              variants={{
                hidden: { opacity: 0, y: 30 },
                visible: { opacity: 1, y: 0 },
              }}
            >
              <h2 className="section-title">
                <span>03.</span> Social Media
              </h2>
              <div className="social-icons">
                <motion.a whileHover={{ scale: 1.15 }} href="https://www.linkedin.com/company/shivam-transworld/about/?viewAsMember=true">
                  <FaLinkedinIn/>
                </motion.a>
                <motion.a whileHover={{ scale: 1.15 }} href="https://www.facebook.com/profile.php?id=61586790875867">
                  <FaFacebookF />
                </motion.a>
              </div>
            </motion.div>

          </motion.div>
        </div>
      </section>

   <section className="map-section">
  <iframe
src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d117466.57811306189!2d70.03665060814008!3d23.066672539935425!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3950b98e8bec0d97%3A0x9d6ccb522ee8f6e0!2sGandhidham%2C%20Gujarat!5e0!3m2!1sen!2sin!4v1768985991362!5m2!1sen!2sin"
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
    allowFullScreen
    title="Shivam Transworld Map"
  ></iframe>
</section>
    </>
  );
};

export default Contact;
